/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Last_Name_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Last Name" |
*
* @param {Team_Manager_Last_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_last_name_placeholder = /** @type {((inputs?: Team_Manager_Last_Name_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Last_Name_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nom")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nachname")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cognome")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Фамилия")
	if (locale === "es") return /** @type {LocalizedString} */ ("Apellido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("姓")
	if (locale === "ja") return /** @type {LocalizedString} */ ("苗字")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपनाम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sobrenome")
	return /** @type {LocalizedString} */ ("Last Name")
});